//represents a modal window that allows the user to make a selection of his playlists
module.exports = ['config', 'Modal', '$timeout', function SelectMyPlaylistsModal(config, Modal, $timeout) {
    var modal;

    return {
        open: function (params, data) {
            modal = Modal.create(
                config.templateRoot + '/templates/playlists/modals/select',
                params,
                data
            ).then(function (modalScope) {

                //this window needs to close when a login form pops up
                modalScope.$on('authentication.required', function () {
                    $timeout(function () {
                        modalScope.$close();
                    }, 300);
                });

                //close the modal when dropping outside
                modalScope.$on('modal.dropfail', function () {
                    modalScope.$close();
                });
            });

            return modal;
        },

        get: function () {
            return modal;
        }
    };
}];



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/services/SelectMyPlaylistsModal.js